import React from 'react';
import createReactClass from 'create-react-class';
import update from 'react-addons-update';
import { Table } from 'react-bootstrap';
import phones from 'telephone-stuff';

import Modal from '../../../common/components/Modal';
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import schema from '../../../routes/permissions/schema';

var Location = createReactClass({

    getInitialState: function () {
        return {
            deleteModal: false,
            editModal: false,
            validators: [],
            edited: false,
            edits: {}
        };
    },

    selectLocation: function () {
        if (this.props.mode == 'select') {
            // console.log(this.props);
            this.props.actions.selectedMetadataItem.bind(null, this.props.location).call();
        } else if (this.props.mode == 'event') {
            this.props.assignLocationToEvent();
        }
    },

    toggleDeleteModal: function () {
        this.setState({
            deleteModal: !this.state.deleteModal
        });
    },

    toggleEditModal: function () {
        if (this.state.editModal) return this.revert();
        this.setState({
            editModal: !this.state.editModal
        });
    },

    handleChange: function (event) {

        if (!this.state.edited) {
            this.setState(function (state, props) {
                return {
                    edited: true,
                    edits: {
                        locationName: this.props.location.locationName,
                        locationAddress: this.props.location.locationAddress,
                        locationContact: this.props.location.locationContact,
                        locationPhone: this.props.location.locationPhone,
                        locationDescription: this.props.location.locationDescription
                    }
                };
            });
        }

        var updates = {};
        updates[event.target.name] = {$set: event.target.value};
        this.setState(function (state) {
            return {
                edits: update(state.edits, updates)
            };
        });
    },

    revert: function () {
        this.setState(this.getInitialState());
    },



    /*
        API Actions
     */
    deleteLocation: function () {
        this.toggleDeleteModal();
        this.props.actions.delete({
            locationID: this.props.location.locationID
        });
    },

    save: function () {
        if (!this.valid()) return;
        // WorkspaceActions.toggleOverlay();
        this.toggleEditModal();
        this.props.actions.edit({
            locationID: this.props.location.locationID,
            locationName: this.state.edits.locationName,
            locationAddress: this.state.edits.locationAddress,
            locationContact: this.state.edits.locationContact,
            locationPhone: this.state.edits.locationPhone,
            locationDescription: this.state.edits.locationDescription
        });
    },

    valid: function () {
        var failed = [], messages = [];

        if (this.state.edits.locationName === '') {
            failed.push('locationName');
            messages.push('Location Name is Required');
        }

        if (failed.length) {
            this.setState({
                validators: failed
            });

            return false;
        }

        return true;
    },

    render: function () {
        var contact = (this.props.location.locationContact) ? this.buildRow('Contact', this.props.location.locationContact) : null,
            description = (this.props.location.locationDescription) ? this.buildRow('Description', this.props.location.locationDescription) : null,
            phone = (this.props.location.locationPhone) ? this.buildRow('Phone', this.props.location.locationPhone) : null;

        var action;

        if (this.props.mode == 'event') {
            if (this.props.isAssignedLocation) {
                action = <button className="btn btn-default" onClick={this.props.remove}><i className="fa fa-minus"/></button>;
            } else {
                // some other location is assigned
                action = <button className="btn btn-default" onClick={this.selectLocation}><i className="fa fa-check"/></button>;
            }
            action = <RestrictedComponent permissionCheck={schema.EVENT_TAB_LOCATION.UPDATE}>
                {action}
            </RestrictedComponent>
        } else if (this.props.mode == 'manage') {
            action = (
                <div className="btn-group">
                    <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_LOCATIONS.UPDATE}>
                        <button className="btn btn-default" onClick={this.toggleEditModal}><i className="fa fa-pencil"/> Edit</button>
                    </RestrictedComponent>
                    <RestrictedComponent permissionCheck={schema.MANAGE_CLIENT_LOCATIONS.DELETE}>
                        <button className="btn btn-default" onClick={this.toggleDeleteModal}><i className="fa fa-trash-can"/> Delete</button>
                    </RestrictedComponent>
                </div>
            );
        } else if (this.props.mode == 'select') {
            action = <button className="btn btn-default" onClick={this.props.actions.selectedMetadataItem.bind(null, this.props.location)}><i className="fa fa-check"/></button>;
        }

        return (
            <div className="panel panel-default location">
                <div className="panel-heading">
                    {this.props.location.locationName}
                </div>
                <div className="panel-body">
                    <Table condensed bordered striped>
                        <tbody>
                            <tr>
                                <td className="data-label">Address</td>
                                <td className="data-value">{this.props.location.locationAddress}</td>
                            </tr>
                            {contact}
                            {phone}
                            {description}
                        </tbody>
                    </Table>

                    <div className="text-right">{action}</div>
                </div>

                {this.renderModals()}
            </div>
        );
    },

    buildRow: function (field, value) {
        return (
            <tr>
                <td className="data-label">{field}</td>
                <td className="data-value">{value}</td>
            </tr>
        );
    },

    renderModals: function () {
        if (this.state.editModal) {

            var locationName = (this.state.edited) ? this.state.edits.locationName : this.props.location.locationName;
            var locationAddress = (this.state.edited) ? this.state.edits.locationAddress : this.props.location.locationAddress;
            var locationContact = (this.state.edited) ? this.state.edits.locationContact : this.props.location.locationContact;
            var locationPhone = (this.state.edited) ? this.state.edits.locationPhone : this.props.location.locationPhone;
            var locationDescription = (this.state.edited) ? this.state.edits.locationDescription : this.props.location.locationDescription;

            var parsedPhone = phones.parse(locationPhone, { truncate: false });
            var valid = {
                locationPhone: locationPhone ? phones.validate(parsedPhone) : true
            };

            const isDuplicate = this.state.edited &&
            this.state.edits.locationName.trim().toLowerCase() !== this.props.location.locationName.trim().toLowerCase() &&
            this.props.locations.some(location => {
                const newLocationName = locationName.trim().toLowerCase()
                return location.locationName.trim().toLowerCase() === newLocationName
            })

            return (
                <Modal
                    saveAction={<button className="btn btn-primary" onClick={this.save} disabled={(!this.state.edited || isDuplicate)}>
                        <i className="fa fa-save"/> Save
                    </button>}
                    cancelModal={this.toggleEditModal}>
                    <Modal.Header>Edit Location</Modal.Header>
                    <Modal.Body>
                        <label>Location Name</label>
                        <input className="form-control" name="locationName" value={locationName} onChange={this.handleChange} placeholder="Required"/>

                        <div style={{margin: '2rem 0'}}/>

                        <label>Address</label>
                        <input className="form-control" name="locationAddress" value={locationAddress} onChange={this.handleChange}/>

                        <div style={{margin: '2rem 0'}}/>

                        <div className="row">
                            <div className="col-md-6">
                                <label>Contact</label>
                                <input className="form-control" name="locationContact" value={locationContact} onChange={this.handleChange}/>
                            </div>

                            <div className="col-md-6">
                                <div className={'form-group' + (valid.locationPhone ? '' : ' has-error')}>
                                    <label>Phone</label>
                                    <input className="form-control"
                                        name="locationPhone"
                                        placeholder="123-123-1234"
                                        value={locationPhone}
                                        onChange={this.handleChange}
                                    />
                                </div>
                            </div>
                        </div>

                        <div style={{margin: '2rem 0'}}/>

                        <label>Location Description</label>
                        <textarea className="form-control" name="locationDescription" value={locationDescription} onChange={this.handleChange}></textarea>
                    </Modal.Body>
                    <Modal.Footer>{isDuplicate ? <div>This location name is already in use</div> : null}</Modal.Footer>
                </Modal>
            );
        } else if (this.state.deleteModal) {
            return (
                <Modal
                    saveAction={<button className="btn btn-danger" onClick={this.deleteLocation}>
                        <i className="fa fa-trash-can"/> Delete
                    </button>}
                    cancelModal={this.toggleDeleteModal}>
                    <Modal.Header>Delete Location</Modal.Header>
                    <Modal.Body>
                        <div className="alert alert-danger">
                            <strong>Are you sure?</strong>
                            <p>This cannot be undone!</p>
                        </div>
                    </Modal.Body>
                    <Modal.Footer></Modal.Footer>
                </Modal>
            );
        }
    }
});

export default Location;
